<div class="legend-line">
  @for (filter of layerType.measurementUnits; track $index) {
    <div class="legend-item__wrapper">
      <app-line-dash-array-view
        [dashArray]="filter.dashArray"
        [color]="filter.color"
      ></app-line-dash-array-view>

      <div class="legend-item__name">
        {{ filter.number}}
      </div>
    </div>
  }
</div>
